import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { toast } from "react-toastify";
import Loader from "semantic-ui-react/dist/es/elements/Loader";
import Popup from "semantic-ui-react/dist/es/modules/Popup";
import { profileSetup, stepsCompleted } from "../../../../actions/globalAction";
import NavbarContainer from "../../../Navbar/NavbarContainer";
import LeftContainer from "../../LeftContainer/LeftContainer";
import CompanyDetailsForms from "./CompanyDetailsForms";
import "./companyDetailsWrapper.scss";
import Scrollbars from "react-custom-scrollbars";
import UseGAEventsTracker from "../../../hooks/UseGAEventsTracker";
import CurrentStepIndicator from "../CurrentStepIndicator";

const companyDetailsWrapper = ({ history, location, company, isMobile }) => {
    const company_name = useSelector((state) => state.globalReducer.company.company_name);
    const dispatch = useDispatch();
    const [submitting, setSubmitting] = useState(false);
    const [industries, setIndustries] = useState([]);
    const [buttonEnabled, setButtonEnabed] = useState(false);
    const GAEventTracker = UseGAEventsTracker("New user SignUp");

    const [values, setValues] = useState({
        user_full_name: company.user_name ? company.user_name : "",
        company_name: "",
        job_title: "",
        contact_no: "",
        industry: null,
        goals: [],
        country: "",
        // timezone: { label: "", value: 0 },
        timezone: null,
        timezone_name: "",
        // company_size: null,
    });
    useEffect(() => {
        // if (company_name) history.push("/profile-setup/social-profiles");
        GAEventTracker("SignUp step 2", `company-${company?.company_identifier}`);
    }, []);

    useEffect(() => {
        //check for values
        const { user_full_name, company_name, job_title, contact_no, industry, goals } = values;
        if (user_full_name !== "" && company_name !== "" && job_title !== "" && goals?.length > 0 && industry !== "" && contact_no !== "")
            setButtonEnabed(true);
        else setButtonEnabed(false);
    }, [values]);

    const handleFormsSubmit = async (e) => {
        e.preventDefault();
        const { user_full_name, company_name, job_title, contact_no, industry, goals } = values;
        if (!buttonEnabled) return;

        if (user_full_name.trim() === "") {
            toast.error("Please enter your Name.");
            return;
        } else if (user_full_name.length > 30) {
            toast.error("Name should not be more than 30 characters.");
            return;
        } else if (user_full_name.length < 3) {
            toast.error("Name must be atleast 3 characters long.");
            return;
        } else if (company_name.trim() === "") {
            toast.error("Please enter your Organization Name.");
            return;
        } else if (company_name.length > 40) {
            toast.error("Company name should not be more than 40 characters.");
            return;
        } else if (company_name.length < 3) {
            toast.error("Company name must be atleast 3 characters long.");
            return;
        } else if (job_title.trim() === "") {
            toast.error("Pease enter your role in the organization.");
            return;
        } else if (job_title.length > 20) {
            toast.error("Role in the organization should not be more than 20 characters.");
            return;
        } else if (job_title.length < 2) {
            toast.error("Role in the organization must be atleast 2 characters long.");
            return;
        } else if (Array.isArray(goals) && !goals.length) {
            toast.error("Please select your goals.");
            return;
        } else if (!industry || industry === "") {
            toast.error("Please select your industry.");
            return;
        } else if (contact_no.trim() === "") {
            toast.error("Please enter your contact number.");
            return;
        } else {
            try {
                const goalsModified = values.goals.map((obj) => obj.value).join(", ");
                // console.log(goalsModified);
                const modifiedVal = { ...values };
                modifiedVal.goals = goalsModified;
                // console.log("final body", modifiedVal);
                setSubmitting(true);
                setTimeout(() => {
                    setSubmitting(false);
                }, 5000);
                let res = await dispatch(profileSetup(modifiedVal));
                if (res?.status && res?.status == 200) {
                    setSubmitting(false);
                    // toast.success("successful");
                    localStorage.setItem("company-datails-setup", JSON.stringify(values));
                    dispatch(stepsCompleted("companyDetails"));
                    history.push("/profile-setup/social-profiles");
                }
            } catch (error) {
                setSubmitting(false);
                toast.error("Something went wrong, Please try again later.");
                console.error("Error", error);
            }
        }
    };

    return (
        <>
            <div className="main__wrapper">
                <div className="details__form__wrapper">
                    <LeftContainer />
                    <Scrollbars autoHide autoHideDuration={300}>
                        <CompanyDetailsForms
                            values={values}
                            setValues={setValues}
                            industries={industries}
                            // varySteps={varySteps}
                            setIndustries={setIndustries}
                            setSubmitting={setSubmitting}
                            // user={props.user}
                            company={company}
                        />
                    </Scrollbars>
                </div>
            </div>
            <div className="porfile__setup__footer">
                <button
                    className={`button back__button  ${isMobile && "mobile__version__button"} `}
                    onClick={() => {
                        history.push("/signout");
                        // history.push("/signin");
                        // history.goBack()
                    }}>
                    Previous
                </button>
                {isMobile ? <div>Step 2 of 4</div> : <CurrentStepIndicator StepCount={2} />}
                <Popup
                    content="Please fill all the form details"
                    inverted
                    disabled={buttonEnabled}
                    size="mini"
                    position="top center"
                    style={{ zIndex: "99999" }}
                    trigger={
                        <button
                            className={`button ${!buttonEnabled && "disabled__mode"}  ${isMobile && "mobile__version__button"}`}
                            onClick={handleFormsSubmit}
                            disabled={submitting}>
                            {/* <span>{submitting && <Loader active size="large" />} Next</span> */}
                            <span className="relative__loader">
                                {submitting ? <Loader active /> : "Next"}
                                {/* Next */}
                            </span>
                        </button>
                    }
                />
            </div>
        </>
    );
};

export default companyDetailsWrapper;
